import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withLocalize } from 'react-localize-redux';
import Popover from '@material-ui/core/Popover';
import { DuCommonTranslations } from 'driscolls-react-utilities';
import DrcButton from './DrcButton';
import Language from '@material-ui/icons/Language';

const styles = (theme) => ({
    headerButtons: {
        float: 'right',
        minWidth: 0,
        border: 'none !important',
        margin: 4,
        '& svg': {
            fontSize: 24
        }
    },
    langPopover: {
        '& .MuiPaper-elevation8': {
            padding: '4px 12px',
            maxWidth: 400,
            width: '100%'
        }
    },
    language: {
        width: 120,
        float: 'right',
        height: 22
    },
    languageBtn: {
        width: '100%',
        margin: '8px 0'
    }
});

class DrcLanguageHeaderButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            anchorElLanguage: null
        };
    }

    changeLanguage = (lang) => {
        this.props.setActiveLanguage(lang.code);
        this.handleLanguageClose();
    };

    handleLanguageClick = (event) => {
        this.setState({ anchorElLanguage: event.currentTarget });
    };

    handleLanguageClose = () => {
        this.setState({ anchorElLanguage: null });
    };

    render() {
        var { classes } = this.props;

        const languageOpen = Boolean(this.state.anchorElLanguage);
        const languageId = languageOpen ? 'lang-popover' : undefined;

        return (
            <React.Fragment>
                <DrcButton aria-describedby={languageId} className={classes.headerButtons} noStyle onClick={this.handleLanguageClick}>
                    <Language />
                </DrcButton>
                <Popover
                    id={languageId}
                    open={languageOpen}
                    anchorEl={this.state.anchorElLanguage}
                    onClose={this.handleLanguageClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                    }}
                    className={classes.langPopover}
                >
                    <div className="row">
                        {DuCommonTranslations.LANGUAGES.map((lang) => {
                            return (
                                <div className="col-xs-12 col-sm-6" key={lang.code}>
                                    <DrcButton
                                        noStyle
                                        isPrimary={this.props.activeLanguage && this.props.activeLanguage.code === lang.code}
                                        isSecondary={!this.props.activeLanguage || this.props.activeLanguage.code !== lang.code}
                                        className={this.props.classes.languageBtn}
                                        onClick={() => this.changeLanguage(lang)}
                                    >{`${lang.name} - ${lang.code}`}</DrcButton>
                                </div>
                            );
                        })}
                    </div>
                </Popover>
            </React.Fragment>
        );
    }
}

export default withLocalize(withStyles(styles)(DrcLanguageHeaderButton));
